import * as z from "zod";

const PriorityInstanceRefSchema = z.object({
  id: z.string(),
});

export const PrioritySchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  color: z.string(),
  type: z.string().nullable().optional(),
  order: z.union([z.string(), z.number()]).optional(),
  icon: z.string().nullable().optional(),
  iconType: z.string().nullable().optional(),
  instanceList: z.array(PriorityInstanceRefSchema).optional(),
});

export type Priority = z.infer<typeof PrioritySchema>;

export type CreatePriorityInput = {
  workspaceId: string;
  name: string;
  color: string;
  icon?: string | null;
  iconType?: string | null;
};

export type UpdatePriorityInput = {
  id: string;
  name?: string;
  color?: string;
  icon?: string | null;
  iconType?: string | null;
};

export const PriorityInstanceSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  priorityId: z.string(),
  priority: PrioritySchema,
});

export type PriorityInstance = z.infer<typeof PriorityInstanceSchema>;
